import React, { useState, useEffect } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import Form from '../../Reusable/Form/Form';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { numberOfItemsPerPage, userRoles } from '../../../constants/globals.js';
import { config } from './UserConfig';
import { findAllUserFilterPageable } from '../../../actions/user';
import { findAllRoles } from '../../../actions/role';
import { findAllKjs } from '../../../actions/kjs';
import { findAllMunicipality } from '../../../actions/municipality';
import { checkForUserRole } from '../../../utils';

const UserFilter = ({
  t,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  findAllUserFilterPageable,
  enums,
  findAllRoles,
  findAllKjs,
  findAllMunicipality,
  kjsList,
  roleList,
  municipalityList,
  loggedUserRoles,
}) => {
  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');

  const isUserSuperAdmin = checkForUserRole(
    loggedUserRoles,
    userRoles?.SUPER_ADMIN?.value
  );

  const isUserMDULSAdmin = checkForUserRole(
    loggedUserRoles,
    userRoles?.ADMIN_MDULS?.value
  );

  let roleListForCombo = roleList;

  if (!isUserSuperAdmin) {
    roleListForCombo = roleListForCombo?.filter(
      (role) => role.roleName !== userRoles?.SUPER_ADMIN?.text
    );
    if (isUserMDULSAdmin) {
      roleListForCombo = roleListForCombo?.filter(
        (role) => role.roleName !== userRoles?.ADMIN_EU?.text
      );
    }
  }

  const { fields } = config({
    enums,
    roleListForCombo,
    kjsList,
    municipalityList,
  });

  useEffect(() => {
    findAllRoles();
    findAllKjs();
    findAllMunicipality();
  }, []);

  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });
  const packConfig = () => {
    return { fields: [...fields] };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);
    const postData = {
      tableName: 'user',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          switch (entry[0]) {
            case 'role.roleName':
            case 'municipality.id':
            case 'kjs.id':
            case 'lastName':
            case 'firstName':
              return (
                entry[1] && {
                  columnName: entry[0],
                  columnValue: entry[1],
                }
              );
            default:
              return null;
          }
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllUserFilterPageable(postData, () => saveFilters(values));
    }
  };

  const onAccordionClick = () =>
    activeKey !== '0' ? setActiveKey('0') : setActiveKey('-1');

  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';

  return (
    <div className="Filters">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={onAccordionClick}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button variant="warning" onClick={resetFilters}>
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className="Form"
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={t}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    roleList: state.role?.rolesHashMapList || [],
    kjsList: state.kjs?.kjsList || [],
    municipalityList: state.municipality?.municipalityList || [],
    loggedUserRoles: state.loggedUser?.loggedUser?.roles || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    findAllUserFilterPageable: (postData, successCallback) => {
      dispatch(
        findAllUserFilterPageable(
          0,
          numberOfItemsPerPage,
          postData,
          successCallback
        )
      );
    },
    findAllRoles: () => {
      dispatch(findAllRoles());
    },
    findAllKjs: () => {
      dispatch(findAllKjs());
    },
    findAllMunicipality: () => {
      dispatch(findAllMunicipality());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(UserFilter, 'UserFilter'))
);
